import { url, language } from 'base-libs';

/**
 * 上报hottag
 * @param  {[type]} tag [description]
 * @return {[type]}     [description]
 */
function hottag(tag, retryTimes = 0) {
    if (retryTimes >= 3){
        return;
    }
    let from = (url.getUrlParam('ADTAG') || '').replace(/\./g, '_');
    let lang = language.getLang(['zh_hk', 'en', 'id'], 'en');
    lang = lang.replace(/\_/g, '-');
    console.log(`hottag: ${tag} /from: ${from}_${lang}`);
    try {
        if (window.MtaH5){
            window.MtaH5.clickStat(tag, {'from': `${from}_${lang}`});
        } else {
            setTimeout(()=>{
                hottag(tag, ++retryTimes);
            }, 2000);
        }
    } catch (e){
        console.log('MtaH5 not loaded ..');
    }
}

export {
    hottag
};
